import { render } from "./TutorialDialog.vue?vue&type=template&id=41962466&scoped=true"
import script from "./TutorialDialog.vue?vue&type=script&lang=js"
export * from "./TutorialDialog.vue?vue&type=script&lang=js"

import "./TutorialDialog.vue?vue&type=style&index=0&id=41962466&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41962466"]])

export default __exports__